import React from 'react'

import { FormattedMessage } from 'react-intl'

import Theme from '@theme'
import { Icon } from '@tribegroup'
import { Provider } from '../types'
import { PLATFORM_OPTIONS } from './filterOptions'
import { PillButton, PillsRow } from './PlatformPills.styled'

const PROVIDER_GLYPH: Record<Provider, string> = {
  instagram: 'social-instagram-colour',
  tiktok: 'social-tiktok-colour',
  youtube: 'social-youtube-colour',
}

interface IProps {
  selected: Provider[] | undefined
  onChange: (next: Provider[] | undefined) => void
}

const PlatformPills: React.FC<IProps> = ({ selected, onChange }) => {
  const toggle = (value: Provider): void => {
    const current = selected ?? []
    const next = current.includes(value) ? current.filter((v) => v !== value) : [...current, value]
    onChange(next.length === 0 ? undefined : next)
  }

  return (
    <PillsRow>
      {PLATFORM_OPTIONS.map((opt) => {
        const active = (selected ?? []).includes(opt.value)
        return (
          <PillButton
            key={opt.value}
            type="button"
            active={active}
            onClick={() => toggle(opt.value)}
            aria-pressed={active}
            data-testid={`platform-pill-${opt.value}`}
          >
            <Icon glyph={PROVIDER_GLYPH[opt.value]} size={1.25} />
            <span style={{ color: active ? Theme.grey900Color : Theme.grey700Color }}>
              <FormattedMessage id={opt.labelKey} />
            </span>
          </PillButton>
        )
      })}
    </PillsRow>
  )
}

export { PlatformPills }
export default PlatformPills
